module.exports = __webpack_public_path__ + "img/invest-page-frame.9b803746.svg";